<div class="brand-search-container">
    <!-- 搜索框 -->
    <div class="input-row">
        <nz-input-group [nzSuffix]="suffixTpl">
            <input type="text" nz-input placeholder="请输入要查询的配件料号" [(ngModel)]="searchValue"
                (keyup.enter)="onSearch()" />
        </nz-input-group>
    </div>
    <ng-template #suffixTpl>
        <i nz-icon nzType="search" (click)="onSearch()"></i>
    </ng-template>

    <ecat-mobile-part-list #partList [showHeader]="false" (clearSearch)="onClearSearch()">
    </ecat-mobile-part-list>
</div>